import {
  presidentCardPath,
  excludePresidentCardPath,
} from '@src/consts/president-card-path'
import { PRESIDENT_CARD_BRAND_NAME } from '@src/utils/brand/const'

export function isPresidentCardPath(pathname: string) {
  return presidentCardPath.some((path) => pathname.startsWith(path))
}

export function isExcludePresidentCardPath(pathname: string) {
  return excludePresidentCardPath.some((path) => pathname.startsWith(path))
}

export const isPresidentByProcessEnv =
  process.env.NEXT_PUBLIC_BRAND === PRESIDENT_CARD_BRAND_NAME
